/**
 * message: Array/Obj avec string  
 * type: String ( ajoute un nom de class, ici error || sucess )
 */
export class Modal {
	constructor(message, type) {
		this.type = type;
		this.message = message;

		this.messageMarkup = ``;

		Object.values(this.message).forEach((msg) => {
			this.messageMarkup += `<p>${msg}</p>`;
		});

		this.markup = `
			<div class="modal ${this.type}">
				<div class="modal__content">
					<div>${this.messageMarkup}</div>
				</div>
				<button class="modal__close"></button>
			</div>`;

		this.render();

		this.Modal = document.querySelector('.modal');

		this.controllers();
	}
	controllers() {
		this.Modal.querySelector('.modal__close').onclick = function(e) {
			e.target.parentNode.remove();
		};
	}
	render() {
		document.body.insertAdjacentHTML('beforeend', this.markup);
	}
}
